// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7702":"63454c6d","8734":"4622b0da"}[chunkId] + ".chunk.css";
};